






















































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import EntityType from '@/models/Shared/EntityType';
import { PersonModule } from '@/store/Customers/PersonModule';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';

@Component({ name: 'Addresses' })
export default class extends SaascadaVue {

    @Prop({required: true})
    entityType: EntityType;

    headers = [
        { text: this.$t('pageText.customers.fields.addressLine1') },
        { text: this.$t('pageText.customers.fields.addressLine2') },
        { text: this.$t('pageText.customers.fields.city') },
        { text: this.$t('pageText.customers.fields.country') },
        { text: this.$t('pageText.customers.fields.postCode') },
        { text: this.$t('pageText.customers.fields.type') },
        { text: this.$t('pageText.customers.fields.fromDate') },
        { text: this.$t('pageText.customers.fields.toDate') }
    ];
    addressesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.addressesPage = +page;
        }
    }

    async beforeMount() {
        if (this.entityType === EntityType.Person) {
            await PersonModule.getAddresses(this.addressesPage);
        } else {
            await OrganisationModule.getAddresses(this.addressesPage);
        }
    }

    @Watch('addressesPage')
    async onAddressesPage() {
        // Update route with tab and page number (if it has changed)
        if (this.addressesPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.addressesPage}` } });
        }
        // Get new addresses
        if (this.entityType === EntityType.Person) {
            await PersonModule.getAddresses(this.addressesPage);
        } else {
            await OrganisationModule.getAddresses(this.addressesPage);
        }
    }

    get addresses() {
        if (this.entityType === EntityType.Person) {
            return PersonModule.addresses;
        } else {
            return OrganisationModule.addresses;
        }
    }

    get loading() {
        if (this.entityType === EntityType.Person) {
            return PersonModule.loadingAddresses;
        } else {
            return OrganisationModule.loadingAddresses;
        }
    }

    get totalAddressesPages() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.totalAddressesPages;
        }
        else {
            return PersonModule.totalAddressesPages;
        }
    }

    get pageSize() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.pageSize;
        }
        else {
            return PersonModule.pageSize;
        }
    }

}
